import ServiceApi from 'vl-common/src/services/service.api';

export const scheduleConfirm = (request) => {
  return async () => {
    const ret = await ServiceApi.post('/booking/appointment', { ...request })
      .then(({ data }) => ({ type: 'RESCHEDULE_CONFIRM_SUCCESS', payload: data }))
      .catch((e) => {
        console.error(e);
        return { type: 'RESCHEDULE_CONFIRM_FAIL', error: e.response };
      });

    return ret;
  };
};

export default scheduleConfirm;
